import React, { Fragment } from 'react';

const BuildingInfo = ({ building, buildingLoading }) => {
  return (
    <Fragment>
      {buildingLoading ? (
        <div className='card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content'>
          <div className='d-flex justify-content-center align-items-center h-100'>
            <div class='spinner-border txt-primary' role='status'>
              <span class='visually-hidden'>Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className='card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content'>
          <div className='mb-3'>
            <h5 className='fw-bold'>id</h5>
            <div className=''>{building.id}</div>
          </div>
          <div className='mb-3'>
            <h5 className='fw-bold'>Name</h5>
            <div className=''>{building.name}</div>
          </div>
          <div className='mb-3'>
            <h5 className='fw-bold'>Client</h5>
            <div className=''>{building.client.title}</div>
          </div>
          <div className='mb-3'>
            <h5 className='fw-bold'>Image</h5>
            <img src={building.image} alt='' className='' height='200' />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default BuildingInfo;
